import { proxyCustomElement, HTMLElement, getAssetPath, h } from '@stencil/core/internal/client';
import { A as AwsService } from './index10.js';
import './index2.js';
import './index3.js';
import { I as InputType, d as defineCustomElement$5 } from './roche-input2.js';
import { M as MessageType, d as defineCustomElement$4 } from './roche-message2.js';
import { d as defineCustomElement$9 } from './roche-button2.js';
import { d as defineCustomElement$8 } from './roche-form2.js';
import { d as defineCustomElement$7 } from './roche-generic-link2.js';
import { d as defineCustomElement$6 } from './roche-icon2.js';
import { d as defineCustomElement$3 } from './roche-select2.js';
import { d as defineCustomElement$2 } from './roche-tooltip2.js';

var ServerResponse;
(function (ServerResponse) {
    ServerResponse[ServerResponse["IDLE"] = 0] = "IDLE";
    ServerResponse[ServerResponse["SUCCESS"] = 1] = "SUCCESS";
    ServerResponse[ServerResponse["ERROR"] = 2] = "ERROR";
})(ServerResponse || (ServerResponse = {}));

const rocheRegistrationCss = ":host{display:block;margin-top:3rem}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}:host .registration-container{max-width:30rem;margin:0 auto}";
const RocheRegistrationStyle0 = rocheRegistrationCss;

const ERRORS = {
    UsernameExistsException: 'UsernameExistsException',
    InvalidParameterException: 'InvalidParameterException',
    InvalidPasswordException: 'InvalidPasswordException',
};
const RocheRegistration$1 = /*@__PURE__*/ proxyCustomElement(class RocheRegistration extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.type = InputType.TEXT;
        this.labelEmail = 'Email';
        this.labelUsername = 'Username';
        this.labelPassword = 'Password';
        this.labelTelephone = 'Phone';
        this.labelPasswordConfirm = 'Confirm Password';
        this.labelSubmit = 'Register';
        this.labelOptinFirst = 'This is an opt-in statement';
        this.labelOptinSecond = 'This is another opt-in statement';
        this.labelOptinNotice = 'This is another opt-in statement';
        this.labelUnmatchedPasswords = 'Your passwords do not match';
        this.labelConfirmRegistration = 'User registered';
        this.labelInvalidParameterException = 'Invalid Password Format';
        this.labelUsernameExistsException = 'This username is already in use';
        this.labelOptin = [
            { label: this.labelOptinFirst, value: 'optin-1' },
            { label: this.labelOptinSecond, value: 'optin-2' },
        ];
        this.urlRegistrationSuccess = null;
        this.msg = 'Registration failed';
        this.sending = false;
        this.user = null;
        this.response = ServerResponse.IDLE;
    }
    static async initAwsService() {
        if (!RocheRegistration.isAwsInitialized) {
            await AwsService.init(getAssetPath('../'));
            RocheRegistration.isAwsInitialized = true;
        }
    }
    static sendGlobalEvent(component) {
        if (!RocheRegistration.eventFired) {
            RocheRegistration.eventFired = true;
            window.dispatchEvent(new CustomEvent('rocheRegistrationComplete', { detail: component }));
        }
    }
    async handleSubmit({ detail }) {
        this.sending = true;
        const { password, passwordConfirm, username, email, } = detail.values;
        if (password !== passwordConfirm) {
            this.response = ServerResponse.ERROR;
            this.msg = this.labelUnmatchedPasswords;
            this.sending = false;
        }
        else {
            try {
                await AwsService.register(username, password, email);
                if (this.urlRegistrationSuccess !== null && this.urlRegistrationSuccess !== '') {
                    window.location.href = this.urlRegistrationSuccess;
                }
                else {
                    this.response = ServerResponse.SUCCESS;
                    this.msg = this.labelConfirmRegistration;
                    this.sending = false;
                }
            }
            catch (error) {
                switch (error.code) {
                    case ERRORS.InvalidParameterException:
                        this.msg = this.labelInvalidParameterException;
                        break;
                    case ERRORS.InvalidPasswordException:
                        this.msg = this.labelInvalidParameterException;
                        break;
                    case ERRORS.UsernameExistsException:
                        this.msg = this.labelUsernameExistsException;
                        break;
                    default:
                        this.msg = error.message;
                }
                this.response = ServerResponse.ERROR;
                this.sending = false;
            }
        }
    }
    // eslint-disable-next-line class-methods-use-this
    async componentWillLoad() {
        await RocheRegistration.initAwsService();
        if (await AwsService.isLoggedIn()) {
            // TODO set other state variables
            RocheRegistration.sendGlobalEvent(this);
        }
    }
    componentDidUpdate() {
        if (this.response === ServerResponse.SUCCESS) {
            RocheRegistration.sendGlobalEvent(this);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    componentDidLoad() {
        // eslint-disable-next-line class-methods-use-this
        window.dispatchEvent(new CustomEvent('rocheRecaptchaAvailable'));
    }
    render() {
        const disabled = this.sending || this.response === ServerResponse.SUCCESS;
        return (h("div", { key: '3e206c9747765c24896bc0d7661bb508e2a4f869', class: "registration-container" }, (this.response === ServerResponse.ERROR) && (h("roche-message", { text: this.msg, type: MessageType.FAIL })), (this.response === ServerResponse.SUCCESS) && (h("roche-message", { text: this.msg, type: MessageType.SUCCESS })), h("roche-form", { key: 'c57bd424c0d7ceee9d23f106db97899e4ce98bf9', "disable-recaptcha": true, submit: this.labelSubmit, disabled: disabled, "disable-submit": true }, h("roche-input", { key: '9bc1335aa78d7c6669238e310b0085d12b3476fb', label: this.labelUsername, type: this.type, name: "username", required: true }), h("roche-input", { key: '9723741a226f615077c57a3d082ae3520e089ba8', label: this.labelEmail, type: InputType.EMAIL, name: "email", required: true }), h("roche-input", { key: 'faabadab39561c11d40bd1fb2a21d72e6cff61e3', label: this.labelPassword, type: InputType.PASSWORD, name: "password", required: true }), h("roche-input", { key: '676a90130e227d6b16d07a710c85215c2eb16c34', label: this.labelPasswordConfirm, type: InputType.PASSWORD, name: "passwordConfirm", required: true }), h("roche-select", { key: '5214cbd82f2e1f660919e9ed12b6578358f319b4', options: this.labelOptin, label: this.labelOptinNotice, "all-required": true, required: true, "multi-select": true }))));
    }
    static get style() { return RocheRegistrationStyle0; }
}, [1, "roche-registration", {
        "type": [1],
        "labelEmail": [1, "label-email"],
        "labelUsername": [1, "label-username"],
        "labelPassword": [1, "label-password"],
        "labelTelephone": [1, "label-telephone"],
        "labelPasswordConfirm": [1, "label-password-confirm"],
        "labelSubmit": [1, "label-submit"],
        "labelOptinFirst": [1, "label-optin-first"],
        "labelOptinSecond": [1, "label-optin-second"],
        "labelOptinNotice": [1, "label-optin-notice"],
        "labelUnmatchedPasswords": [1, "label-unmatched-passwords"],
        "labelConfirmRegistration": [1, "label-confirm-registration"],
        "labelInvalidParameterException": [1, "label-invalid-parameter-exception"],
        "labelUsernameExistsException": [1, "label-username-exists-exception"],
        "labelOptin": [16],
        "urlRegistrationSuccess": [8, "url-registration-success"],
        "msg": [1],
        "sending": [32],
        "user": [32],
        "response": [32]
    }, [[0, "rocheFormSubmit", "handleSubmit"]]]);
RocheRegistration$1.isAwsInitialized = false;
RocheRegistration$1.eventFired = false;
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-registration", "roche-button", "roche-form", "roche-generic-link", "roche-icon", "roche-input", "roche-message", "roche-select", "roche-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-registration":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheRegistration$1);
            }
            break;
        case "roche-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "roche-form":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "roche-generic-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "roche-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "roche-message":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheRegistration = RocheRegistration$1;
const defineCustomElement = defineCustomElement$1;

export { RocheRegistration, defineCustomElement };

//# sourceMappingURL=roche-registration.js.map